<template>
	<v-card flat class="">
		<v-card-title>
			<h3 class="text-h5">Surat Pengantar</h3>
			<v-spacer></v-spacer>
			<v-select v-model="table.status" outlined hide-details="" dense label="Status :" :items="table.statuss"
				@change="getDataFromApi()"></v-select>
			<v-autocomplete v-model="table.filter.id_institusi" :items="opt_institusi_pendidikans" outlined dense
				label="Institusi Pendidikan :" item-text="nama" item-value="id" hide-details=""
				@change="getDataFromApi()"></v-autocomplete>
			<v-btn small color="secondary" @click="getDataFromApi()" class="mr-4"><v-icon>{{ icons.mdiMagnify
			}}</v-icon></v-btn>
		</v-card-title>
		<v-data-table :headers="table.headers" :items="table.items" :options.sync="tableOptions"
			:server-items-length="table.totalItems" :loading="table.loading" :search="table.search" class="elevation-1">
			<template v-slot:item.institusi="{ item }">
				{{ item.nama_institusi }}/ {{ item.nama_prodi }}
			</template>
			<template v-slot:item.stase="{ item }">
				{{ item.nama_stase }}, {{ item.stase }}
			</template>
			<template v-slot:item.tanggal="{ item }">
				{{ formatDate(item.tanggal_awal) }} / {{ formatDate(item.tanggal_akhir) }}
			</template>
			<template v-slot:item.file_url="{ item }">
				<embed type="application/pdf" :src="item.file_url + '#toolbar=0&navpanes=0&scrollbar=0'" width="500"
					height="300" />
				<br /><v-btn color="success" x-small @click="lihatPengantar(item.id, item.file_url)">Lihat
					File</v-btn>
			</template>
			<template v-slot:item.actions="{ item }">
				<v-chip small color="info" class="mb-2">{{ item.status }}</v-chip><br />
				<v-btn v-if="item.status == 'Masuk'" color="primary" x-small @click="openSuratJawaban(item)"
					title="Surat Jawaban">
					<v-icon x-small>
						{{ icons.mdiPlus }}
					</v-icon>
					Surat Jawaban
				</v-btn>
				<v-btn v-if="item.status == 'Balas'" color="primary" x-small @click="addPraktik(item)"
					title="Tambah Praktik">
					<v-icon x-small>
						{{ icons.mdiPlus }}
					</v-icon>
					Tambah Praktik
				</v-btn>
				<router-link v-if="item.status == 'Jadwal'"
					:to="{ name: 'AdminPraktikAnggota', params: { id: item.id_periode_praktik } }"
					title="Lihat Siswa dan Pembimbing Praktik">
					<v-btn color="info" x-small>
						<v-icon x-small>
							{{ icons.mdiEye }}
						</v-icon> Lihat Jadwal
					</v-btn>
				</router-link>
			</template>
			<template v-slot:no-data>
				<v-btn color="primary" @click="getDataFromApi" x-small>
					Reload
				</v-btn>
			</template>
		</v-data-table>

		<v-dialog v-model="dialog" max-width="800px">
			<v-card>
				<v-card-title>
					<span class="text-h6">Tambah Jadwal Praktik</span>
				</v-card-title>
				<v-card-text>
					<v-row>
						<v-col cols="12" sm="6" md="6">
							<v-autocomplete v-model="form.editedItem.id_institusi" :items="institusi_pendidikans"
								outlined dense label="* Institusi Pendidikan :" item-text="nama" item-value="id"
								hide-details=""></v-autocomplete>
						</v-col>
						<v-col cols="12" sm="6" md="6">
							<v-autocomplete v-model="form.editedItem.id_prodi" :items="prodis" outlined dense
								label="* Prodi :" item-text="nama" item-value="id" hide-details=""></v-autocomplete>
						</v-col>
						<v-col cols="12" sm="6" md="6">
							<v-select v-model="form.editedItem.profesi" outlined hide-details="" dense
								label="* Kelompok :" :items="form.profesis" class="mb-3"></v-select>
						</v-col>
						<v-col cols="12" sm="6" md="6">
							<v-autocomplete v-model="form.editedItem.stase_id" :items="form.stases" outlined dense
								hide-details="" label="Stase :" item-text="text" item-value="id"></v-autocomplete>
						</v-col>
						<v-col cols="12" sm="6" md="6">
							<label>* File Pengantar</label><br />
							<a target="_blank" :href="form.editedItem.file_url">Lihat
								File Terupload</a>
						</v-col>
						<v-col cols="12" sm="6" md="6">
							<label>* File Surat Jawaban</label><br />
							<a target="_blank" :href="form.editedItem.file_url_jawaban">Lihat
								File Terupload</a>
						</v-col>
						<v-col cols="12" sm="6" md="6">
							<v-text-field v-model="form.editedItem.tanggal_awal" type="date" outlined
								label="Tanggal Awal :" hide-details=""></v-text-field>
						</v-col>
						<v-col cols="12" sm="6" md="6">
							<v-text-field v-model="form.editedItem.tanggal_akhir" type="date" outlined
								label="Tanggal Akhir :" hide-details=""></v-text-field>
						</v-col>
						<v-col cols="12">
							<v-text-field v-model="form.editedItem.nama" outlined dense hide-details=""
								label="Nama / Keterangan :"></v-text-field>
						</v-col>
						<v-col cols="12" sm="6" md="6">
							<span>* File Jadwal</span>
							<input type="file" label="Pilih File" accept="application/pdf" ref="file"
								@change="onFileChange()" />
						</v-col>
						<v-col cols="12" sm="6" md="6">
							<label>* File SPT:</label><br />
							<input type="file" label="Pilih File" accept="application/pdf" ref="file_spt"
								@change="onFileSPTChange()" />
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-btn color="primary" @click="save()" small>
						Simpan
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogSuratJawaban" max-width="700px">
			<v-card>
				<v-card-title>
					<span class="text-h6">Surat Jawaban</span>
				</v-card-title>
				<v-card-text>
					<v-row>
						<v-col cols="12" sm="6" md="6">
							<v-autocomplete readonly v-model="form.editedItem.id_institusi"
								:items="institusi_pendidikans" outlined dense label="* Institusi Pendidikan :"
								item-text="nama" item-value="id" hide-details=""></v-autocomplete>
						</v-col>
						<v-col cols="12" sm="6" md="6">
							<v-autocomplete readonly v-model="form.editedItem.id_prodi" :items="prodis" outlined dense
								label="* Prodi :" item-text="nama" item-value="id" hide-details=""></v-autocomplete>
						</v-col>
						<v-col cols="12" sm="6" md="6">
							<v-select readonly v-model="form.editedItem.profesi" outlined hide-details="" dense
								label="* Kelompok :" :items="form.profesis" class="mb-3"></v-select>
						</v-col>
						<v-col cols="12" sm="6" md="6">
							<v-autocomplete readonly v-model="form.editedItem.stase_id" :items="form.stases" outlined
								dense hide-details="" label="Stase :" item-text="text" item-value="id"></v-autocomplete>
						</v-col>
						<v-col cols="12">
							<label>* File Pengantar</label><br />
							<a target="_blank" :href="form.editedItem.file_url">Lihat
								File Terupload</a>
						</v-col>
						<v-col cols="12" sm="6" md="6">
							<v-text-field readonly v-model="form.editedItem.tanggal_awal" type="date" outlined
								label="Tanggal Awal :" hide-details=""></v-text-field>
						</v-col>
						<v-col cols="12" sm="6" md="6">
							<v-text-field readonly v-model="form.editedItem.tanggal_akhir" type="date" outlined
								label="Tanggal Akhir :" hide-details=""></v-text-field>
						</v-col>
						<v-col cols="12" sm="6" md="6" v-if="form.editedItem.file_name_jawaban == null">
							<label>* File Surat Jawaban</label><br />
							<input type="file" label="Pilih File" accept="application/pdf" ref="file_surat_jawaban"
								@change="onFileSuratJawabanChange()" />
						</v-col>
						<v-col cols="12" sm="6" md="6" v-else>
							<label>* File Surat Jawaban</label><br />
							<a target="_blank" :href="form.editedItem.file_url_jawaban">Lihat
								File Terupload</a>
							<input type="file" label="Pilih File" accept="application/pdf" ref="file_surat_jawaban"
								@change="onFileSuratJawabanChange()" />
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-btn color="primary" @click="saveSuratJawaban()" small>
						Simpan
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-card>
</template>

<script>
import { axiosPostAuth, axiosGetAuth } from '@/utils/axios'
import { mdiEye, mdiPencil, mdiMagnify, mdiPlus } from '@mdi/js'

export default {
	components: {
	},
	data: () => ({
		icons: {
			mdiEye,
			mdiPencil,
			mdiMagnify, mdiPlus
		},
		tableOptions: {},
		table: {
			loading: true,
			headers: [
				{ text: 'No', align: 'start', sortable: false, value: 'no' },
				{ text: 'Institusi', value: 'institusi', sortable: false },
				{ text: 'Kelompok', value: 'profesi', sortable: false },
				{ text: 'Stase', value: 'stase', sortable: false },
				{ text: 'Tanggal Awal/ Akhir', value: 'tanggal', sortable: false },
				{ text: 'File Pengantar', value: 'file_url', sortable: false },
				{ text: 'Status/ Aksi', value: 'actions', sortable: false },
			],
			items: [],
			totalItems: 0,
			search: '',
			filter: {
				id_institusi: 'SEMUA',
			},
			status: 'Masuk',
			statuss: ['Masuk', 'Balas', 'Jadwal', 'SEMUA']
		},
		dialog: false,
		dialogSuratJawaban: false,
		form: {
			editedIndex: -1,
			file_temp: '',
			file_surat_jawaban_temp: '',
			file_spt_temp: '',
			editedItem: {
				id_institusi: '',
				id_prodi: '',
				profesi: '',
				stase_id: 0,
				tanggal_awal: '',
				tanggal_akhir: '',
				file_url: null,
				file_surat_jawaban_url: null,
			},
			defaultItem: {
				id_institusi: '',
				id_prodi: '',
				profesi: '',
				stase_id: 0,
				tanggal_awal: '',
				tanggal_akhir: '',
				file_url: null,
				file_surat_jawaban_url: null,
			},
			profesis: [
				'Dokter',
				'PPDS',
				'Keperawatan,Kebidanan, dan Tenaga Kesehatan Lain',
			],
			stases: [],
		},
		institusi_pendidikans: [],
		opt_institusi_pendidikans: [],
		prodis: [],
	}),
	watch: {
		tableOptions: {
			handler() {
				this.getDataFromApi()
			},
			deep: true,
		},
	},
	computed: {
		formTitle() {
			return this.form.editedIndex === -1 ? 'Tambah Data' : 'Edit Data'
		},
		user() {
			return this.$store.getters.user
		},
	},
	created() {
		this.getOptInstitusiPendidikan()
		this.getInstitusiPendidikan()
		this.getProdi()
		this.getStase()
	},
	methods: {
		onFileChange() {
			this.form.file_temp = this.$refs.file.files.item(0)
		},
		onFileSPTChange() {
			this.form.file_spt_temp = this.$refs.file_spt.files.item(0)
		},
		getInstitusiPendidikan() {
			axiosGetAuth('api/RegisterLanjutan/getInstitusiPendidikans')
				.then(response => {
					if (response.code === 200) {
						this.institusi_pendidikans = response.datas
					} else {
						alert(response.message)
					}
				})
				.catch(error => {
					alert(error)
				})
		},
		getOptInstitusiPendidikan() {
			axiosGetAuth('api/Master/getOptInstitusiPendidikans')
				.then(response => {
					if (response.code === 200) {
						this.opt_institusi_pendidikans = response.datas
					} else {
						alert(response.message)
					}
				})
				.catch(error => {
					alert(error)
				})
		},
		getProdi() {
			axiosGetAuth('api/RegisterLanjutan/getProdis')
				.then(response => {
					if (response.code === 200) {
						this.prodis = response.datas
					} else {
						alert(response.message)
					}
				})
				.catch(error => {
					alert(error)
				})
		},
		getStase() {
			axiosGetAuth('api/Praktik/getStase')
				.then(response => {
					this.form.stases = response.data
				})
				.catch(error => {
					alert(error)
				})
		},
		save() {
			const fmData = new FormData()
			fmData.append('nama', this.form.editedItem.nama)
			fmData.append('id_institusi', this.form.editedItem.id_institusi)
			fmData.append('id_prodi', this.form.editedItem.id_prodi)
			fmData.append('profesi', this.form.editedItem.profesi)
			fmData.append('stase_id', this.form.editedItem.stase_id)
			fmData.append('tanggal_awal', this.form.editedItem.tanggal_awal)
			fmData.append('tanggal_akhir', this.form.editedItem.tanggal_akhir)
			if (this.form.file_temp != undefined) {
				fmData.append('file', this.form.file_temp)
			}
			if (this.form.file_spt_temp != undefined) {
				fmData.append('file_spt', this.form.file_spt_temp)
			}
			fmData.append('id_surat_pengantar', this.form.editedItem.id)
			axiosPostAuth('api/Praktik/addPraktik', fmData)
				.then(response => {
					if (response.code === 200) {
						this.$notify({
							type: 'success',
							title: 'Berhasil',
							text: response.message,
						});
						this.dialog = false
						this.getDataFromApi()
					}
					else {
						alert(response.message)
					}
				})
				.catch(error => {
					alert(error)
				})
		},
		getDataFromApi() {
			const { page, itemsPerPage } = this.tableOptions
			const fmData = new FormData()
			fmData.append('page', page)
			fmData.append('itemsPerPage', itemsPerPage)
			fmData.append('id_institusi', this.table.filter.id_institusi)
			fmData.append('search', this.table.search)
			fmData.append('status', this.table.status)
			axiosPostAuth('api/Universitas/getSuratPengantar', fmData)
				.then(response => {
					this.table.items = response.data
					this.table.totalItems = response.total
					this.table.loading = false
				})
				.catch(error => {
					alert(error)
				})
		},
		addPraktik(item) {
			this.form.editedItem = Object.assign({}, item)
			// this.form.editedItem.file_url = null
			this.dialog = true
		},
		lihatPengantar(surat_id, link_url) {
			window.open(
				link_url,
				'_blank'
			);
			// const fmData = new FormData()
			// fmData.append('id', surat_id)
			// fmData.append('status_tujuan', 'lihat')
			// axiosPostAuth('api/PengantarPraktik/updateStatus', fmData)
			// 	.then(response => {
			// 		if (response.code === 200) {
			// 			window.open(
			// 				link_url,
			// 				'_blank'
			// 			);
			// 			this.getDataFromApi()
			// 		}
			// 		else {
			// 			alert(response.message)
			// 		}
			// 	})
			// 	.catch(error => {
			// 		alert(error)
			// 	})
		},
		openSuratJawaban(item) {
			this.form.editedIndex = this.table.items.indexOf(item)
			this.form.editedItem = Object.assign({}, item)
			if (this.$refs.file_surat_jawaban != undefined) this.$refs.file_surat_jawaban.value = ''
			this.dialogSuratJawaban = true
		},
		onFileSuratJawabanChange() {
			this.form.file_surat_jawaban_temp = this.$refs.file_surat_jawaban.files.item(0)
		},
		saveSuratJawaban() {
			if (this.form.editedItem.file_name_jawaban != null) {
				const fmData = new FormData()
				fmData.append('surat_jawaban_id', this.form.editedItem.surat_jawaban_id)
				fmData.append('file_name_jawaban_lama', this.form.editedItem.file_name_jawaban)
				if (this.form.file_surat_jawaban_temp != undefined) {
					fmData.append('file_surat_jawaban', this.form.file_surat_jawaban_temp)
				}
				axiosPostAuth('api/PraktikSuratJawaban/updateSuratJawaban', fmData)
					.then(response => {
						if (response.code === 200) {
							this.$notify({
								type: 'success',
								title: 'Berhasil',
								text: response.message,
							});
							this.dialogSuratJawaban = false
							this.getDataFromApi()
						}
						else {
							alert(response.message)
						}
					})
					.catch(error => {
						alert(error)
					})
			} else {
				const fmData = new FormData()
				fmData.append('surat_pengantar_id', this.form.editedItem.id)
				if (this.form.file_surat_jawaban_temp != undefined) {
					fmData.append('file_surat_jawaban', this.form.file_surat_jawaban_temp)
				}
				axiosPostAuth('api/PraktikSuratJawaban/saveSuratJawaban', fmData)
					.then(response => {
						if (response.code === 200) {
							this.$notify({
								type: 'success',
								title: 'Berhasil',
								text: response.message,
							});
							this.dialogSuratJawaban = false
							this.getDataFromApi()
						}
						else {
							alert(response.message)
						}
					})
					.catch(error => {
						alert(error)
					})
			}
		},
	},
}
</script>